import React, { forwardRef } from "react";
import { FacTextFieldProps } from "./FacTextField.type";
import FacTextField from "./FacTextField.component";

export const withFacTextField = ({
    inputProps: defaultinputProps,
    InputProps: defaultInputProps,
    ...defaultProps
}: FacTextFieldProps) => {
    // eslint-disable-next-line react/display-name
    return forwardRef<HTMLDivElement, FacTextFieldProps>(
        ({ InputLabelProps, inputProps, InputProps, ...props }, ref) => (
            <FacTextField
                ref={ref}
                inputProps={{
                    ...defaultinputProps,
                    ...inputProps,
                }}
                InputProps={{
                    ...defaultInputProps,
                    ...InputProps,
                }}
                InputLabelProps={{ shrink: true, ...InputLabelProps }}
                {...defaultProps}
                {...props}
            />
        ),
    );
};
